import React, { useEffect } from "react";
import { Link } from "react-router-dom";

// Função para converter URL do YouTube em iframe embed
const getYouTubeEmbed = (youtubeUrl) => {
  if (!youtubeUrl) return null;
  
  // Se já é um iframe HTML completo, retorna direto
  if (youtubeUrl.includes('<iframe')) {
    return youtubeUrl;
  }
  
  // Se já é uma URL de embed do YouTube (youtube.com/embed/...), usa direto
  if (youtubeUrl.includes('youtube.com/embed/')) {
    const embedUrl = youtubeUrl.trim();
    return `<div style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; border-radius: 8px;"><iframe style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" src="${embedUrl}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
  }
  
  // Extrai o ID do vídeo do YouTube de diferentes formatos de URL
  const youtubeRegex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
  const youtubeMatch = youtubeUrl.match(youtubeRegex);
  
  if (youtubeMatch) {
    const videoId = youtubeMatch[1];
    return `<div style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; border-radius: 8px;"><iframe style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
  }
  
  // Se não for reconhecido, retorna null
  return null;
};

const VideoModal = ({ isOpen, onClose, product }) => {
  // Bloqueia o scroll do body quando o modal está aberto
  useEffect(() => {
    if (isOpen) {
      // Salva o scroll atual
      const scrollY = window.scrollY;
      // Bloqueia o scroll
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      
      return () => {
        // Restaura o scroll quando o modal fecha
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);

  if (!isOpen || !product) return null;

  const embedHtml = product.youtube_link ? getYouTubeEmbed(product.youtube_link) : null;
  const hasComplementary = product.complementary_description && String(product.complementary_description).trim().length > 0;

  return (
    <>
      {/* Backdrop */}
      <div
        className="modal-backdrop fade show"
        onClick={onClose}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 10000,
        }}
      />
      
      {/* Modal */}
      <div
        className="modal fade show"
        style={{
          display: "flex",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 10001,
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-lg"
          style={{ 
            maxWidth: "900px",
            width: "90%",
            margin: "auto",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content" style={{ maxHeight: "90vh", display: "flex", flexDirection: "column", borderRadius: 8 }}>
            <div className="modal-header" style={{ position: "relative", padding: "1rem", flexShrink: 0 }}>
              <h5 className="modal-title" style={{ flex: 1 }}>
                {product.product_name}
              </h5>
              <button
                type="button"
                className="close"
                onClick={onClose}
                title="Fechar"
                style={{
                  position: "absolute",
                  right: "16px",
                  top: "16px",
                  background: "transparent",
                  border: "none",
                  fontSize: "28px",
                  cursor: "pointer",
                  padding: 0,
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                aria-label="Fechar"
              >
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ padding: "1.5rem", overflowY: "auto", flex: 1 }}>
              {embedHtml && (
                <div style={{ marginBottom: "20px" }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: embedHtml,
                    }}
                  />
                </div>
              )}
              
              {hasComplementary && (
                <div
                  style={{
                    background: "#F2F6F7",
                    padding: "20px",
                    borderRadius: "8px",
                    whiteSpace: "pre-wrap",
                    marginBottom: "20px",
                  }}
                >
                  <div style={{ margin: 0, color: "#000" }}>
                    {String(product.complementary_description).trim()}
                  </div>
                </div>
              )}

              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <Link to="/autenticacao" title="Fazer login para ver mais detalhes">
                  <button
                    className="btn-small theme-btn-1 btn-effect-1"
                    style={{ minWidth: "200px" }}
                    type="button"
                    title="Fazer login para ver mais detalhes"
                  >
                    <i className="fa-solid fa-right-to-bracket"></i> Fazer login para ver mais detalhes
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoModal;
